export const CAPTCHA_CONFIG = {
  /** Ключи для подключения */
  siteKey: 'ysc1_pD7bQNDIs1XfwCZwtie1sDooq3IdGM8PapYHZAH7cf2528c8',
  /** Id контейнера */
  containerId: 'captcha-container',
  /** Скрипт капчи */
  scriptUrl: 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=onloadFunction',
} as const;

/** Политика конфиденциальности Яндекс SmartCaptcha */
export const CAPTCHA_POLICY_LINK = 'https://yandex.ru/legal/smartcaptcha_notice/';
